import { createIcon } from '@chakra-ui/react';

export const Cart = createIcon({
  displayName: 'Cart',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 6l-.3-3H2.5a.5.5 0 000 1h2.29L6 16h14.17L22 6H6zm13.33 9H6.89L6.1 7h14.73l-1.5 8zM18 17a2 2 0 10-.001 3.999A2 2 0 0018 17zm0 3a1 1 0 110-2 1 1 0 010 2zM8 17a2 2 0 10-.001 3.999A2 2 0 008 17zm0 3a1 1 0 110-2 1 1 0 010 2z"
      clipRule="evenodd"
    />
  ),
});
